module.exports = __webpack_public_path__ + "cuttingline4.png?67e9d74221e2a9ec57d6e9f60bbdf6ce";